@if (!user) {
  <ftr-icon-legacy icon="AccountCircle" [size]="size" color="GreyLight" align="Sub" />
}

@if (user) {
  <div class="user-avatar" [ngClass]="['user-avatar--' + (size | lowercase), 'user-avatar--' + color]">
    {{ userInitials ?? '' | uppercase }}
  </div>
}
